// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-icon-wrapper[data-v-f07b2bea] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n}\n.info-icon-wrapper-span[data-v-f07b2bea] {\n  margin-left: 4px;\n  margin-bottom: 6px;\n}\n.table-wrapper[data-v-f07b2bea] {\n  margin-left: 36px;\n  margin-bottom: 20px;\n}\n\n/* ... rest of your styles ... */", ""]);
// Exports
module.exports = exports;
